import { Component, Input, type OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TitleCasePipe } from '@angular/common';
import { SafePipe } from '../../pipes/dom-sanitizer.pipe';

import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../services/storage.service';
import { type UserProfile } from '../../models/user-profile';
import { StorageEnum } from '../../enums/storage.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../services/util.service';
import { PageHeader } from '../../models/page-header.model';

@Component({
  selector: 'app-page-header',
  imports: [MatFormFieldModule, MatSelectModule, MatButtonModule, RouterModule, SafePipe, TitleCasePipe],
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss',
})
export class PageHeaderComponent implements OnInit {
  loginRes: UserProfile = this.storageS.getSession(StorageEnum.LoginResponse);
  multiRes: UserProfile = this.storageS.getSession(StorageEnum.MultiAccountResponse);

  @Input() headerData: PageHeader = new PageHeader();

  constructor(
    private readonly storageS: StorageService,
    private readonly utilS: UtilService,
  ) {}

  ngOnInit(): void {
    this.utilS.consoleGroup('headerData: ', this.headerData);
  }
}
